import { ENABLE_FILE_UPLOAD, ENABLE_DIARIZATION, ENABLE_FAST_FILE_UPLOAD, IS_DEV_BUILD } from "../../AppConstants";

export enum HostAppSettingName {
    AugLoopCloudALServiceUrl = 'AugLoopCloudALServiceUrl',
    IsProductionEnvironment = 'IsProductionEnvironment',
    TranscriptionSessionId = 'TranscriptionSessionId',
    IsFileUploadEnabled = 'IsFileUploadEnabled',
    IsFastFileUploadEnabled = 'IsFastFileUploadEnabled',
    IsDiarizationEnabled = 'IsDiarizationEnabled',
    MonthlyMinutesUsed = 'MonthlyMinutesUsed',
    HasStoredTranscription = 'HasStoredTranscription',
    StoredTranscription = 'StoredTranscription',
    IsFreemiumUpsellEnabled = 'IsFreemiumUpsellEnabled',
    IsLicensedUser = 'IsLicensedUser'
};

/**
 * Is a wrapper around the settings that are passed in to the SDX from the hosting app
 */
export class HostAppSettings {
    /**
     * Returns a string parsed from reading the setting
     * @param settingName  Name of setting to read
     */
    public static GetSettingAsNumber(settingName: HostAppSettingName): number {
        return Office.context.document.settings.get(settingName.toString());
    }

    /**
     * Returns a string parsed from reading the setting
     * @param settingName  Name of setting to read
     */
    public static GetSettingAsString(settingName: HostAppSettingName): string {
        return Office.context.document.settings.get(settingName.toString());
    }

    /**
     * Sets a setting in the in-memory settings bag
     * @param settingName  Name of setting to set
     * @param value Value to set to
     */
    public static Set(settingName: HostAppSettingName, value: any): void {
        Office.context.document.settings.set(settingName, JSON.stringify(value));
    }

    /**
     * Returns false if setting doesn't exist
     * @param settingName Name of setting to read
     */
    public static IsSettingTrue(settingName: HostAppSettingName): boolean {
        const settingValue: string = this.GetSettingAsString(settingName);
        if (settingValue) {
            return (settingValue.toLowerCase() == 'true');
        } else {
            return false;
        }
    }
};

export function IsFileUploadEnabled(): boolean {
    return HostAppSettings.IsSettingTrue(HostAppSettingName.IsFileUploadEnabled) || ENABLE_FILE_UPLOAD;
}

export function IsDiarizationEnabled(): boolean {
    return HostAppSettings.IsSettingTrue(HostAppSettingName.IsDiarizationEnabled) || ENABLE_DIARIZATION;
}

export function IsFastFileUploadEnabled(): boolean {
    return IsFileUploadEnabled() && (HostAppSettings.IsSettingTrue(HostAppSettingName.IsFastFileUploadEnabled) || ENABLE_FAST_FILE_UPLOAD);
}

export function GetInitialMonthlyMinutesUsed(): number {
    if (IS_DEV_BUILD)
        return 42;

    return HostAppSettings.GetSettingAsNumber(HostAppSettingName.MonthlyMinutesUsed);
}